import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li">{`台灣敏捷協會 理事/敏捷教練`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`高雄敏捷社群 創辦人/組織者`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`一卡通票證 敏捷轉型顧問`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`台灣易格斯 敏捷教練`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`緯創資通 經理與技術經理`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`嘉實資訊 經理`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`寶石星球 營運長/技術長暨共同創辦人`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Facebook: `}<a parentName="p" {...{
            "href": "https://www.facebook.com/herchg"
          }}>{`https://www.facebook.com/herchg`}</a></p>
      </li>
    </ul>
    <p>{`相關演講經歷:`}</p>
    <ol>
      <li parentName="ol">{`Agile Summit 2019 工作坊`}</li>
      <li parentName="ol">{`Agile Tour Kaohsiung`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      